module.exports = __webpack_public_path__ + "static/img/cont3606.3f92533.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont3606.jpg
// module id = 213p
// module chunks = 0